import React, { useContext } from 'react';

import { gql } from '@nerdwallet/apollo';

import { Box, Link, Stack, Text } from '@nerdwallet/currency';

import { Impression } from '@nerdwallet/analytics/react/impression';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { ExperimentContext } from '@nerdwallet/features';
import classes from '@nerdwallet/base-styles/classes';

import {
  CcHeadToHeadLinksFragment,
  CreditCardsOfferV2,
} from '~/generated-gql/generated-types';

import { texts, ENTITY_NAME, SECTION_NAME } from './constants';

interface Props {
  article: CcHeadToHeadLinksFragment;
}

const CCHeadToHeadLinks: React.GraphqlFC<Props> = ({ article }) => {
  const { creditCardsHeadToHead: creditCards } = article;

  const experimentContext = useContext(ExperimentContext);
  const modelExecutionIds = experimentContext?.modelExecutionIds;

  if (!creditCards) {
    return null;
  }

  return (
    <Box className={classes(['margin-bottom-2', 'margin-bottom-3--wide'])}>
      <Stack spacing={2}>
        <Text size="large">{texts.title}</Text>
        {creditCards.map((cc: CreditCardsOfferV2) => {
          if (!Object.prototype.hasOwnProperty.call(cc, 'cta') || !cc.cta.link)
            return null;
          return (
            // Legacy
            <ElementImpression
              id={ENTITY_NAME}
              elementName={ENTITY_NAME}
              sectionCategory={SECTION_NAME}
            >
              {/* Default */}
              <Impression
                eventType="product_impression"
                payload={{
                  entity_name: ENTITY_NAME,
                  section_name: SECTION_NAME,
                  model_execution_ids: modelExecutionIds,
                  destination_url: cc.cta.link,
                  marketplace_institution_id: cc.analyticsProps.institutionId,
                  marketplace_offer_id: cc.analyticsProps.offerId,
                  marketplace_product_id: cc.analyticsProps.productId,
                  marketplace_product_type: cc.productType,
                  monetizable: cc.monetizable,
                }}
              >
                <Link href={cc.cta.link} target="_blank" rel="noreferrer">
                  {texts.linkText + cc.displayName}
                </Link>
              </Impression>
            </ElementImpression>
          );
        })}
      </Stack>
    </Box>
  );
};

CCHeadToHeadLinks.fragment = gql`
  fragment CCHeadToHeadLinks on Article {
    creditCardsHeadToHead {
      productType
      ... on CreditCardsOfferV2 {
        displayName
      }
      ... on MarketplaceEntityWithPlacementInterface {
        analyticsProps {
          hasLegacyImpression
          legacyAdditionalEventData
          legacyIssuer
          legacySlug
          legacyVertical
          institutionId
          offerId
          productId
        }
        cta {
          link
        }
        monetizable
      }
    }
  }
`;

export default CCHeadToHeadLinks;
